// extracted by mini-css-extract-plugin
export default {"orderInformation":"Yt-z","paymentUpdateSuccess":"Zt-z","orderNumber":"_t-z"};